import { createI18n } from "vue-i18n";
import en from "./en";

const meta: any = import.meta as any;
const LocalStore = (window as any).localStorage;
const baseUrl = meta?.env?.BASE_URL;

// console.log(meta, "meta========");

let LANGPATH = baseUrl + "assets/i18n/";
if (meta.env?.MODE === "production") {
    LANGPATH = baseUrl + "i18n/";
}
export const Language_Token_key = "CHARM_VIBE_LANGUAGES";

export type LangOpts = {
    language?: string;
    legacy?: false;
    globalInjection?: true; //全局生效$t
    messages?: any;
};

export class I18NClass {
    public currentLanguage = "en";

    private static _instance: I18NClass;
    public i18n: any;
    private loadedLanguages: string[];
    private defaultLangMessage: any;
    public static getInstance(opts?: LangOpts): I18NClass {
        if (!I18NClass._instance) {
            I18NClass._instance = new I18NClass(opts);
        }

        return I18NClass._instance;
    }

    constructor(opts?: LangOpts) {
        const lang = (window?.navigator.language || "en").toLocaleLowerCase(); // 浏览器语言
        const languageLocal =
            LocalStore.getItem(Language_Token_key) ||
            lang.split("-")[0] ||
            "en"; // 存储在本地，若本地没有，采用浏览器语言
        this.currentLanguage = opts?.language || languageLocal;
        this.defaultLangMessage = { en };
        this.loadedLanguages = ["en"];
        this.i18n = this.initCreateI18n();
    }
    initCreateI18n() {
        // 准备语言环境信息
        const i18n = createI18n({
            legacy: false,
            globalInjection: true, //全局生效$t
            locale: this.currentLanguage, // 设置默认语言
            messages: this.defaultLangMessage,
        });
        return i18n;
    }

    getCurrentLanguage(): string {
        return this.i18n.global.locale.value;
    }

    setCurrentLanguage(lang: string): string {
        console.log("setCurrentLanguage", lang);
        this.i18n.global.locale.value = lang;
        LocalStore.setItem(Language_Token_key, lang);
        return lang;
    }

    ChangeLanguageAsync(language: string): Promise<string> {
        // 如果语言相同
        //console.log("ChangeLanguageAsync path", LANGPATH, language);
        if (this.i18n.global.locale.value === language) {
            return Promise.resolve(this.setCurrentLanguage(language));
        }
        // 如果语言已经加载
        if (this.loadedLanguages.includes(language)) {
            return Promise.resolve(this.setCurrentLanguage(language));
        }
        //如果路径为空 直接返回默认语言
        if (!LANGPATH) {
            return Promise.resolve(
                this.setCurrentLanguage(this.currentLanguage)
            );
        }
        // 如果尚未加载语言,动态引入
        //console.log(`${LANGPATH}${language}.js`, "path================");
        return import(/* @vite-ignore */ `${LANGPATH}${language}.js`)
            .then((resLang) => {
                console.log("import i18n lang path", LANGPATH, language);
                this.i18n.global.setLocaleMessage(language, resLang.default);
                this.loadedLanguages.push(language);
                return this.setCurrentLanguage(language);
            })
            .catch((error) => {
                console.warn(`[${language}] language is not found.`, error);
                return this.setCurrentLanguage("en");
            });
    }
}
